import { brl } from "../lib/formato";

// Espaço inquebrável: o texto não pode partir entre "R$" e o número no card
const semQuebra = (t) => t.replace(/ /g, "\u00A0");

export default function FormasPagamento({ pagamento, pmVisual, compacto }) {
  const { formas, selecionada, setSelecionada, recebido, setRecebido, abrirPix, abrirTroco, total } = pagamento;

  const escolher = (code, ehDinheiro) => {
    if (selecionada === code) {
      setSelecionada(null);
      if (ehDinheiro) setRecebido("");
      return;
    }
    setSelecionada(code);
    // PIX Online pergunta antes de gerar o QR (v1.5.519); Dinheiro abre o troco (v1.5.518)
    if (/pix_online/i.test(code)) abrirPix();
    else if (ehDinheiro) abrirTroco();
  };

  return (
    <div className={compacto ? "grid grid-cols-3 gap-2" : "grid grid-cols-2 lg:grid-cols-3 gap-3"}>
      {formas.map((method) => {
        const code = method.code || method.id;
        const vis = pmVisual(code, method.label);
        const Icone = method.icon || vis.icon;
        const cor = method.color || vis.color;
        const ativa = selecionada === code;
        const ehDinheiro = /dinheiro/i.test(`${code} ${method.label}`);
        return (
          <button
            key={method.id || code}
            type="button"
            onClick={() => escolher(code, ehDinheiro)}
            className={`${compacto ? "px-1.5 py-2 min-h-[60px] flex-col justify-center gap-1 text-center" : "px-4 py-4 min-h-[72px] gap-3 text-left"} rounded-xl border-2 transition-all flex items-center ${ativa ? "border-primary bg-primary/10" : "border-transparent bg-muted hover:border-muted-foreground/30"}`}
          >
            <div className={`${compacto ? "p-1.5" : "p-2.5"} rounded-lg ${cor} text-white shrink-0`}><Icone className={compacto ? "w-4 h-4" : "w-5 h-5"} /></div>
            <div className={compacto ? "w-full min-w-0" : "flex-1 min-w-0"}>
              <span className={`font-semibold truncate block ${compacto ? "text-xs" : "text-base"}`}>{method.label}</span>
              {/* Recebido/troco dentro do card do Dinheiro (v1.5.525) */}
              {ehDinheiro && ativa && recebido && (
                <span
                  onClick={(e) => { e.stopPropagation(); abrirTroco(); }}
                  title="Toque para recalcular o troco"
                  className="block text-xs leading-tight text-green-600 dark:text-green-400 tabular-nums hover:underline"
                >
                  {semQuebra(`Recebido ${brl(recebido)} · Troco ${brl(Math.max(0, parseFloat(recebido || 0) - total))}`)}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
